export default __webpack_public_path__ + "static/crop1-608bd59203f725fcfdd17b77fd17c6d3.jpeg";